// adminService.js
import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class AdminService {
  fetchAdmins = (page = 1, pageSize = 10, search = '', roleFilter = '') => {
    let url = `${BASE_URL}/v1/user/admin-users?page=${page}&page_size=${pageSize}`;

    if (search) {
      // Check if search value is an email (contains @)
      if (search.includes('@')) {
        url += `&email=${encodeURIComponent(search)}`;
      } else {
        url += `&name=${encodeURIComponent(search)}`;
      }
    }

    if (roleFilter) {
      // Convert role filter to role_id: "Admin" -> 1, "User" -> 2
      const roleId =
        roleFilter === 'Admin' ? 1 : roleFilter === 'User' ? 2 : '';
      if (roleId) {
        url += `&role_id=${roleId}`;
      }
    }

    return axiosInstance.get(url);
  };

  createAdmin = (adminData) => {
    return axiosInstance.post(`${BASE_URL}/v1/user/register`, adminData);
  };

  updateAdmin = (adminId, adminData) => {
    return axiosInstance.put(`${BASE_URL}/v1/user/${adminId}`, adminData);
  };

  deleteAdmin = (adminId) => {
    return axiosInstance.delete(`${BASE_URL}/v1/user/${adminId}`);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AdminService();
